export default [
	{
		key: 'name',
		title: 'Name',
		scopedSlots: {customRender: 'name'},
	}, {
		key: 'branch',
		title: 'Branch',
		scopedSlots: {customRender: 'branch'}
	}, {
		key: 'branch_code',
		title: 'Branch Code',
		scopedSlots: {customRender: 'branch_code'}
	}, {
		key: 'phone_number',
		title: 'Phone Number',
		scopedSlots: {customRender: 'phone_number'}
	}, {
		key: 'username',
		title: 'Username',
		scopedSlots: {customRender: 'username'}
	}, {
		key: 'email',
		title: 'Email',
		scopedSlots: {customRender: 'email'}
	}, {
		key: 'role',
		title: 'Role',
		scopedSlots: {customRender: 'role'}
	}, {
		key: 'status',
		title: 'Status',
		scopedSlots: {customRender: 'status'}
	}, {
		dataIndex: 'updated_at',
		key: 'updatedAt',
		title: 'Last Updated',
		scopedSlots: {customRender: 'updatedAt'}
	}, {
		key: 'action',
		title: '',
		scopedSlots: {customRender: 'action'}
	}
]
